import { SET_PROFILES, GET_PROFILES } from './actionTypes'

export function setProfiles(data) {
  return {
    type: SET_PROFILES,
    data,
  }
}

export function getProfileSaga(data) {
  return {
    type: GET_PROFILES,
    data,
  }
}
